<template>
  <section class="section is-fullheight animated preFadeInUp fadeInUp">
    <div class="columns has-text-centered is-centered" v-if="loading">
      <loading
        line-fg-color="var(--primary-color)"
        size="massive"
        class="margin-100"
        text-fg-color="#fff"
        message="الرجاء الإنتظار"
      />
    </div>

    <div class="container" v-else>
      <!-- Title -->

      <div>
        <div class="section-title-wrapper has-text-centered mt-40">
          <div class="clean-bg-symbol">
            <i class="sl sl-icon-layers"></i>
          </div>
          <div>
            <h6
              class="clean-section-title has-text-black has-text-weight-bold is-small"
            >
              صندوق الطلبات {{ requeststring }}
            </h6>
            <h2
              class="subtitle is-5 pt-10 pb-10 has-text-black has-text-weight-bold"
            >
              لديك {{ requests.length }} طلب
            </h2>
          </div>
        </div>
      </div>

      <div class="columns is-centered mt-40">
        <div class="column">
          <!-- <b-table
            :data="isEmpty ? [] : requests"
                    :bordered="isBordered"
            :striped="isStriped"
            :narrowed="isNarrowed"
            :hoverable="isHoverable"
            :loading="isLoading"
            :focusable="isFocusable"
            :mobile-cards="hasMobileCards"
            
          >
            <template slot-scope="props">
              <b-table-column field="id" label="رقم" width="40" numeric>{{ props.row.id }}</b-table-column>
              <b-table-column field="name" label="الطلب"  >{{ props.row.name }}</b-table-column>
              <b-table-column field="Status" label="الحالة"  ><status :id=" props.row.Status"></status></b-table-column>
              <b-table-column field="createdAt" label="تاريخ الطلب"  >{{ props.row.createdAt }}</b-table-column>
              <b-table-column field="CompletedAt" label="تاريخ الانتهاء"  >{{ props.row.CompletedAt }}</b-table-column>
              <b-table-column field="Notes" label="ملاحظات" >{{ props.row.Notes }}</b-table-column>
              <b-table-column field="actions" label="نشاطات"  >   <button
                    class="button is-rounded is-dark is-shadowless"
                    @click="viewhistory(request.id)"
                  >
                    <b>عرض تفاصيل</b>
                  </button></b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                  </p>
                  <p>Nothing here.</p>
                </div>
              </section>
            </template>
          </b-table> -->

          <table class="table is-narrow is-striped mb-40">
            <thead>
              <tr>
                <th>رقم</th>
                <th>الطلب</th>
                <th>الحالة</th>
                <th>تاريخ الطلب</th>
                <th>تاريخ الانتهاء</th>
                <th>ملاحظات</th>
                <th>نشاطات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in requests" :key="request.id">
                <th>{{ request.id }}</th>

                <td>
                  {{ request.name }}
                </td>
                <td>
                  <status :id="request.Status"></status>
                </td>
                <td>{{ request.createdAt }}</td>

                <td>{{ request.CompletedAt }}</td>

                <td>{{ request.Notes }}</td>
                <td>
                  <button
                    class="button is-rounded is-dark is-shadowless"
                    @click="viewhistory(request.id)"
                  >
                    <b>عرض تفاصيل</b>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal :active.sync="isComponentModalActive" has-modal-card>
      <history :id="requestid" :url="historyurl"></history>
    </b-modal>
  </section>
</template>

<script>
import moment from "moment";
import { request } from "http";

export default {
  name: "Requestinboxdetailed",
  props: ["requeststring", "serviceid", "requesturl", "historyurl"],
  data() {
    return {
      loading: false,
      requests: null,
      requestnames: null,
      requestid: null,
      name: null,
      isComponentModalActive: false,
      isEmpty: false,
      isBordered: true,
      isStriped: false,
      isNarrowed: true,
      isHoverable: false,
      isFocusable: false,
      isLoading: false,
      hasMobileCards: true,
    };
  },
  created() {
    this.loading = true;
    var user = JSON.parse(localStorage.getItem("user"));

    axios
      .get(this.requesturl + user[1])
      .then((response) => {
        this.$root.kick(response.data.message);
        this.requests = response.data.results;

        axios.get("Services/withActions/" + this.serviceid).then((response) => {
          this.$root.kick(response.data.message);
          if (response.data.status == "success") {
            this.requestnames = response.data.results.ServiceActions;
            this.requests.map((request) => {
              request.name = this.requestnames.find(
                (obj) => request.ServicAction_Id === obj.id
              ).name;
              return request;
            });
            this.loading = false;
          } else {
            alert("fail");
          }
        });
      })
      .catch((error) => {
        console.log(error);
        // this.$router.push('/');
      });
  },
  methods: {
    viewhistory(id) {
      this.requestid = id;
      // this.name = name;
      this.isComponentModalActive = true;
    },
  },
};
</script>
